/**
 * 진입점(QR) 공용 로직. 진입점 목록 화면과 프로젝트의 진입점 선택 팝업이 함께 쓴다.
 *
 * 두 화면이 같은 규칙으로 검색되어야 한다 — 목록에서 "광화문"으로 찾은 것과
 * 선택 팝업에서 "광화문"으로 찾은 것이 다르면 담당자가 신뢰할 수 없다.
 * 그래서 라벨 매핑과 검색 술어를 여기 한 곳에만 둔다.
 */

/** 목록·팝업에 표시하는 타입 라벨. 검색도 이 라벨 기준이다. */
export const SPOT_TYPE_LABELS = {
    OFFLINE: "오프라인",
    ONLINE: "온라인",
    ADVERTISEMENT: "광고",
    POINT_EVENT: "포인트 신규 가입",
    POINT_EARN: "포인트 적립",
}

/** 종전 if-else 체인과 동일하게, 모르는 타입은 "오프라인" 으로 표시한다. */
export const spotTypeLabel = (type) => SPOT_TYPE_LABELS[type] ?? "오프라인"

/** 화면에 표시되는 ID = uid 앞 8자. */
export const spotShortId = (uid) => (uid ?? "").substring(0, 8)

/**
 * 화면에 보이는 값(이름 / ID / 타입)으로 찾는다.
 * 주소처럼 목록에 없는 값은 대상에서 뺐다 — 안 보이는 값에 걸리면 "왜 이게 나오지" 가 된다.
 * 같은 이유로 uid 는 화면에 보이는 앞 8자만 대상이다.
 */
export const matchesSpotKeyword = (spot, keyword) => {
    const query = (keyword ?? "").trim().toLowerCase()
    if (query === "") {
        return true
    }
    return (spot.name ?? "").toLowerCase().includes(query)
        || spotShortId(spot.uid).toLowerCase().includes(query)
        || spotTypeLabel(spot.type).toLowerCase().includes(query)
}
